import _classCallCheck from "C:\\Users\\fgrassinger\\Documents\\Arbeitsprojekte\\InteractiveLegend_Horizon\\node_modules\\@babel\\runtime/helpers/esm/classCallCheck";
import _createClass from "C:\\Users\\fgrassinger\\Documents\\Arbeitsprojekte\\InteractiveLegend_Horizon\\node_modules\\@babel\\runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "C:\\Users\\fgrassinger\\Documents\\Arbeitsprojekte\\InteractiveLegend_Horizon\\node_modules\\@babel\\runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "C:\\Users\\fgrassinger\\Documents\\Arbeitsprojekte\\InteractiveLegend_Horizon\\node_modules\\@babel\\runtime/helpers/esm/getPrototypeOf";
import _inherits from "C:\\Users\\fgrassinger\\Documents\\Arbeitsprojekte\\InteractiveLegend_Horizon\\node_modules\\@babel\\runtime/helpers/esm/inherits";
import { isArray } from 'vega-util';
import * as log from '../log';
import { BaseConcatModel } from './baseconcat';
import { buildModel } from './buildmodel';
import { parseRepeatLayoutSize } from './layoutsize/parse';
export var RepeatModel =
/*#__PURE__*/
function (_BaseConcatModel) {
  _inherits(RepeatModel, _BaseConcatModel);

  function RepeatModel(spec, parent, parentGivenName, repeatValues, config) {
    var _this;

    _classCallCheck(this, RepeatModel);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(RepeatModel).call(this, spec, 'repeat', parent, parentGivenName, config, repeatValues, spec.resolve));

    if (spec.resolve && spec.resolve.axis && (spec.resolve.axis.x === 'shared' || spec.resolve.axis.y === 'shared')) {
      log.warn(log.message.REPEAT_CANNOT_SHARE_AXIS);
    }

    _this.repeat = spec.repeat;
    _this.children = _this._initChildren(spec, _this.repeat, repeatValues, config);
    return _this;
  }

  _createClass(RepeatModel, [{
    key: "_initChildren",
    value: function _initChildren(spec, repeat, repeater, config) {
      var children = [];
      var row = !isArray(repeat) && repeat.row || [repeater ? repeater.row : null];
      var column = !isArray(repeat) && repeat.column || [repeater ? repeater.column : null];
      var repeatValues = isArray(repeat) && repeat || [repeater ? repeater.repeat : null]; // cross product

      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = repeatValues[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var repeatValue = _step.value;
          var _iteratorNormalCompletion2 = true;
          var _didIteratorError2 = false;
          var _iteratorError2 = undefined;

          try {
            for (var _iterator2 = row[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
              var rowValue = _step2.value;
              var _iteratorNormalCompletion3 = true;
              var _didIteratorError3 = false;
              var _iteratorError3 = undefined;

              try {
                for (var _iterator3 = column[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
                  var columnValue = _step3.value;
                  var name = (repeatValue ? "__repeat_repeat_".concat(repeatValue) : '') + (rowValue ? "__repeat_row_".concat(rowValue) : '') + (columnValue ? "__repeat_column_".concat(columnValue) : '');
                  var childRepeat = {
                    repeat: repeatValue,
                    row: rowValue,
                    column: columnValue
                  };
                  children.push(buildModel(spec.spec, this, this.getName('child' + name), undefined, childRepeat, config, false));
                }
              } catch (err) {
                _didIteratorError3 = true;
                _iteratorError3 = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion3 && _iterator3.return != null) {
                    _iterator3.return();
                  }
                } finally {
                  if (_didIteratorError3) {
                    throw _iteratorError3;
                  }
                }
              }
            }
          } catch (err) {
            _didIteratorError2 = true;
            _iteratorError2 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
                _iterator2.return();
              }
            } finally {
              if (_didIteratorError2) {
                throw _iteratorError2;
              }
            }
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return != null) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      return children;
    }
  }, {
    key: "parseLayoutSize",
    value: function parseLayoutSize() {
      parseRepeatLayoutSize(this);
    }
  }, {
    key: "assembleDefaultLayout",
    value: function assembleDefaultLayout() {
      var repeat = this.repeat;
      var columns = isArray(repeat) ? undefined : repeat.column ? repeat.column.length : 1;
      return Object.assign({}, columns ? {
        columns: columns
      } : {}, {
        bounds: 'full',
        align: 'all'
      });
    }
  }]);

  return RepeatModel;
}(BaseConcatModel);